import { Pipe, PipeTransform } from "@angular/core";
import { LanguageService } from "../services/language.service";









@Pipe({
   name: 'translate'
})
export class LanguagePipe implements PipeTransform
{

   constructor(
      private lang_s: LanguageService
   ){}


   transform(word: any, ...args: any[])
   {

      // word to translate
      let word_to_translate = word;

      // all languages data
      let language_data = this.lang_s.get_site_languages().getValue().language_data;
      // if word have no translate header return the word as its
      if ( !language_data[args[0]] ) return '';

      // else, get translated word
      let new_word = language_data[args[0]][word_to_translate];

      // if translatione exist
      if ( new_word )
      {
         return new_word;
      }
      else
      {
         return '';
      }



   }




}
